import { COLORS, TYPE, SPACE } from './tokens'
import SectionLabel from './SectionLabel'

const DANGER = '#C04A3D'
const AMBER = '#B7791F'

function riskColor(level) {
  return level === 'high' ? DANGER : AMBER
}

export default function NeedsReviewSection({ findings, riskMap, dispositionMap, locked }) {
  const flagged = (findings || []).filter(f => {
    const risk = riskMap?.[f.id]
    if (!risk) return false
    if (risk.level !== 'high' && risk.level !== 'medium') return false
    // Skip findings the advisor already handled
    const disposition = dispositionMap?.[f.id]?.disposition || 'pending'
    return disposition === 'pending'
  })

  if (flagged.length === 0) return null

  return (
    <section data-print="hide" style={{
      maxWidth: SPACE.sectionMaxWidth,
      margin: '0 auto',
      padding: '20px 24px',
      background: `${DANGER}08`,
      border: `1px solid ${DANGER}40`,
      borderRadius: '4px'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
        <span style={{
          ...TYPE.smallCaps,
          color: DANGER
        }}>Findings needing your review · {flagged.length}</span>
      </div>
      <p style={{ ...TYPE.body, color: COLORS.bodyText, marginTop: 0, marginBottom: '20px' }}>
        {locked
          ? 'These findings were flagged by our hallucination-risk screen and reviewed during sign-off. Retained here for reference.'
          : 'These findings were flagged by our hallucination-risk screen. Verify before signing off.'}
      </p>
      <ul style={{ margin: 0, padding: 0, listStyle: 'none' }}>
        {flagged.map(f => {
          const risk = riskMap[f.id]
          return (
            <li key={f.id} style={{
              padding: '12px 0',
              borderTop: `1px solid ${COLORS.hairline}`
            }}>
              <div style={{ display: 'flex', gap: '12px', alignItems: 'baseline' }}>
                <span style={{
                  ...TYPE.smallCaps,
                  color: riskColor(risk.level),
                  minWidth: '80px'
                }}>{risk.level} risk</span>
                <div style={{ flex: 1 }}>
                  <div style={{ ...TYPE.body, color: COLORS.bodyText, marginBottom: '4px' }}>
                    {f.title}
                  </div>
                  <ul style={{ margin: 0, padding: 0, listStyle: 'none' }}>
                    {risk.reasons.map((reason, i) => (
                      <li key={i} style={{ ...TYPE.supporting, color: COLORS.mutedText }}>
                        · {reason}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </li>
          )
        })}
      </ul>
    </section>
  )
}
